{
  "_provenance": {
    "ns": "crisis",
    "source": "CrisisCallout, CrisisDisclosure and EscalationBanner — gated; the numbers are params, never translated (R3-B8) (#2109 R3 lane L7)"
  },
  "banner": {
    "critical": {
      "label": "Whenever you’re ready, you can keep talking here.",
      "message": "If you’re in immediate danger, call {{emergency}}. You can call, text or chat with {{lifeline}} any hour."
    },
    "dismiss": "Dismiss",
    "high": {
      "label": "Noticed",
      "message": "If you’re in immediate danger, please call {{emergency}} now. Otherwise, please call or text {{lifeline}} to speak with a crisis counselor."
    },
    "medium": {
      "label": "Noticed"
    },
    "resources": {
      "emergency": "Emergency",
      "lifeline": "{{lifeline}} Suicide & Crisis Lifeline"
    }
  },
  "callout": {
    "ariaLabel": "Crisis resources",
    "emergency": "<detail>If you need immediate assistance because you are in danger or experiencing an emergency, </detail><call>call {{emergency}}</call>",
    "eyebrow": "If tonight is hard",
    "headline": "You don’t have to carry this alone right now.",
    "lifeline": "<call>Call or text {{lifeline}}</call><detail> — Suicide & Crisis Lifeline. 24/7, free, confidential.</detail>"
  },
  "disclosure": {
    "ariaLabel": "Crisis and safety resources",
    "emergency": "• Call {{emergency}} for any medical or safety emergency",
    "inDanger": "If you or your child are in immediate danger, in crisis, or thinking about suicide or self-harm:",
    "inlineLink": "Crisis? Call {{lifeline}} or {{emergency}}",
    "lede": "TRF Imagine is not a substitute for emergency or professional care.",
    "lifeline": "• Call or text {{lifeline}} — Suicide & Crisis Lifeline (24/7, free, confidential)",
    "medicalTeam": "For medical questions about your child’s diagnosis, treatment, or symptoms, contact your medical team or call your hospital’s after-hours line."
  },
  "helpEyebrow": "If you need someone tonight"
}
